module.exports = __webpack_public_path__ + "static/c2_image-763bb077f2c1a01177a14606c0a91ab7.png";